module.exports = __webpack_public_path__ + "img/responsive hospitium-02.467fba15.jpg";